/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketItemRequest model module.
 * @module model/PerplayStatisticsControllerDtoMarketItemRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketItemRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketItemRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketItemRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoMarketItemRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketItemRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketItemRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketItemRequest} The populated <code>PerplayStatisticsControllerDtoMarketItemRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketItemRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('itemType')) {
                obj['itemType'] = ApiClient.convertToType(data['itemType'], 'String');
            }
            if (data.hasOwnProperty('itemLevel')) {
                obj['itemLevel'] = ApiClient.convertToType(data['itemLevel'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketItemRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketItemRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoMarketItemRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['itemType'] && !(typeof data['itemType'] === 'string' || data['itemType'] instanceof String)) {
            throw new Error("Expected the field `itemType` to be a primitive type in the JSON string but got " + data['itemType']);
        }
        // ensure the json data is a string
        if (data['itemLevel'] && !(typeof data['itemLevel'] === 'string' || data['itemLevel'] instanceof String)) {
            throw new Error("Expected the field `itemLevel` to be a primitive type in the JSON string but got " + data['itemLevel']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoMarketItemRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoMarketItemRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoMarketItemRequest.prototype['endDate'] = undefined;

/**
 * @member {String} itemType
 */
PerplayStatisticsControllerDtoMarketItemRequest.prototype['itemType'] = undefined;

/**
 * @member {String} itemLevel
 */
PerplayStatisticsControllerDtoMarketItemRequest.prototype['itemLevel'] = undefined;






export default PerplayStatisticsControllerDtoMarketItemRequest;

